<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="plate">
        <div class="title">申请信息</div>
        <div class="apply-info">
          <div class="status">
            <template v-if="detail.applyStatus == 2">
              <img src="@/assets/icon-status-audit.png" alt="" />
              <p>待审核</p>
            </template>
            <template v-if="detail.applyStatus == 3">
              <img src="@/assets/icon-status-close.png" alt="" />
              <p>审核拒绝</p>
            </template>
            <template v-if="detail.applyStatus == 4">
              <img src="@/assets/icon-status-pass.png" alt="" />
              <p>审核通过</p>
            </template>
          </div>
          <div class="info">
            <span>注册申请时间：{{ detail.applyTime }}</span>
            <span>联系人姓名：{{ detail.liaisonName }}</span>
            <span>注册手机号：{{ detail.loginMobile }}</span>
          </div>
        </div>
      </div>
      <div class="plate">
        <div class="title">合作社信息</div>
        <table border cellpadding="0" cellspacing="0" class="table-static">
          <tr>
            <td rowspan="3" class="img img-business">
              <img
                :src="detail.businessLicenseUrl"
                @click="previeImg(detail.businessLicenseUrl)"
              />
            </td>
            <th>名称</th>
            <td>{{ detail.cooperativeName }}</td>
            <th>统一社会信用代码</th>
            <td>{{ detail.socialCreditCode }}</td>
            <th>所在地区</th>
            <td>
              {{ detail.provinceName }}{{ detail.cityName
              }}{{ detail.areaName }}
            </td>
          </tr>
          <tr>
            <th>住所</th>
            <td>{{ detail.address }}</td>
            <th>法定代表人</th>
            <td>{{ detail.corName }}</td>
            <th>法定代表人电话</th>
            <td>{{ detail.corMobile }}</td>
          </tr>
          <tr>
            <th>成员出资总额</th>
            <td>{{ detail.registeredCapital }}</td>
            <th>成立时间</th>
            <td>{{ detail.foundingTime }}</td>
            <th></th>
            <td></td>
          </tr>
        </table>
      </div>

      <div class="plate">
        <div class="title">理事长信息</div>
        <table border cellpadding="0" cellspacing="0" class="table-static">
          <tr>
            <td rowspan="2" class="img img-idcard">
              <img
                :src="detail.cardPortraitUrl"
                @click="previeImg(detail.cardPortraitUrl)"
              />
              <img
                :src="detail.cardEmblemUrl"
                @click="previeImg(detail.cardEmblemUrl)"
              />
            </td>
            <th>理事长姓名</th>
            <td>{{ detail.directorName }}</td>
            <th rowspan="2">头像</th>
            <td rowspan="2" class="img img-avatar">
              <img :src="detail.directorHeadUrl" />
            </td>
            <th>电话</th>
            <td>{{ detail.directorMobile }}</td>
          </tr>
          <tr>
            <th>身份证号码</th>
            <td>{{ detail.directorIdCard }}</td>
            <th>住址</th>
            <td>{{ detail.directorAddress }}</td>
          </tr>
        </table>
      </div>
      <div class="plate">
        <div class="title">合作社荣誉信息</div>
        <div class="pics">
          <div
            class="thumb"
            v-for="item in detail.cooHonorFileList"
            :key="item.id"
          >
            <img :src="item.picPath" @click="previeImg(item.picPath)" />
          </div>
        </div>
      </div>
      <div class="plate">
        <div class="title">合作社经营场地信息</div>
        <div class="pics">
          <div
            class="thumb"
            v-for="item in detail.cooBusinessPlaceFileList"
            :key="item.id"
          >
            <img :src="item.picPath" @click="previeImg(item.picPath)" />
          </div>
        </div>
      </div>
      <div class="plate">
        <div class="title">业务负责人</div>
        <table
          border
          cellpadding="0"
          cellspacing="0"
          class="table-static"
          style="width: 60%"
        >
          <tr>
            <th>业务区域</th>
            <td>{{ detail.businessZoneName }}</td>
            <th>业务员</th>
            <td>{{ detail.businessPersonName }}</td>
          </tr>
        </table>
      </div>
      <div class="plate">
        <div class="title">审核记录</div>
        <el-table :data="detail.auditRecordList">
          <el-table-column
            prop="uptTime"
            label="审核时间"
            min-width="25%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="auditUserName"
            label="审核人员"
            min-width="25%"
            align="center"
          ></el-table-column>
          <el-table-column label="操作结果" min-width="25%" align="center">
            <template slot-scope="{ row }">
              <template v-if="row.applyStatus == 3">审核拒绝</template>
              <template v-if="row.applyStatus == 4">审核通过</template>
            </template>
          </el-table-column>
          <el-table-column
            prop="auditRemark"
            label="备注"
            min-width="25%"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="previeImgVisible" title="图片预览">
      <div class="previewImg">
        <img class="img" width="100%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  name: "CooperativeApplyDetail",
  data() {
    return {
      cooApplyId: "", //合作社申请id
      examineRecords: [], //审核记录
      detail: {},
      previeImgVisible: false,
      previewImgUrl: "",
    };
  },

  created() {
    let { cooApplyId } = this.$route.query;
    this.cooApplyId = cooApplyId;
    this.getCooperativeApplyDetail();
  },
  beforeRouteEnter(to, from, next) {
    let targetPath = "";
    switch (to.query.dataSource) {
      case "2":
        targetPath = "/cooperative/apply-examine/list";
        break;
      case "3":
        targetPath = "/cooperative/apply-examine/batch";
        break;
    }
    to.meta.targetPath = targetPath;
    next((vm) => {});
  },
  methods: {
    // 获取审核信息
    getCooperativeApplyDetail() {
      this.$http.cooperative
        .getCooperativeApplyDetail({ cooApplyId: this.cooApplyId })
        .then((res) => {
          this.detail = res.data;
        });
    },
    // 图片预览
    previeImg(imgUrl) {
      this.previewImgUrl = imgUrl;
      this.previeImgVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding-left: 0 !important;
  padding-right: 0 !important;
  .apply-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .status {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
      display: flex;
      align-items: center;
      padding-right: 48px;
      position: relative;
      .icon {
        height: 42px;
        margin-right: 8px;
      }
      &:after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 26px;
        background: #aeaeae;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -13px;
      }
    }
    .info {
      span {
        font-size: 16px;
        color: #222222;
        margin: 0 40px;
      }
    }
  }
  .plate {
    padding: 10px 20px;
    .title {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &:before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 18px;
        background: #018388;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
  }
  .table-static {
    th {
      width: 150px;
      text-align: right;
    }
    td {
      width: 310px;
      &.img {
        width: auto;
        text-align: center;
      }
    }
    .img-business {
      img {
        max-width: 250px;
        max-height: 132px;
        cursor: pointer;
      }
    }
    .img-idcard {
      img {
        height: 86px;
        cursor: pointer;
      }
    }
    .img-avatar {
      text-align: left;
      img {
        height: 75px;
      }
    }
  }
  .pics {
    display: flex;
    flex-wrap: wrap;
    .thumb {
      width: 160px;
      height: 180px;
      border: 1px solid #dfdfdf;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      margin-bottom: 20px;
      img {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
      }
    }
  }
}
.previewImg {
  width: 60vw;
  height: 60vh;
}
</style>
